import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageBasedComponent } from '@app/pages/page.based.component';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IframeReportComponent } from '@app/shared/components/iframe-report/iframe-report.component';

@Component({
  selector: 'app-supervisor-dashboard',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    IframeReportComponent,
  ],
  templateUrl: './supervisor-dashboard.component.html',
  styleUrl: './supervisor-dashboard.component.css'
})
export class SupervisorDashboardComponent extends PageBasedComponent {
  
  reportName = this.route.params.pipe(map((p) => p['id']));
  
  constructor(
    public route: ActivatedRoute,
    private sanitizer: DomSanitizer,
  ) {
    super();

  }
  
  safeSrc: SafeResourceUrl;
    
  override ngOnInit() {
    super.ngOnInit();
    
  }

}
